export default __webpack_public_path__ + "4a21878de95e45b8e94ef805bdb75c51.png";